import { type GetHookResponse } from '../hooks'
import { useAccountStatuses } from './list'
import { type AccountStatusData, type AccountStatusId, sortAccountStatuses } from '@terros/common'
import { useCallback, useMemo } from 'react'

export const useRecruitStages = (): GetHookResponse<AccountStatusData[]> => {
  const { data: accountStatuses, ...rest } = useAccountStatuses()
  const inputStages = useMemo(() => {
    if (!accountStatuses?.statuses) return []
    return sortAccountStatuses(accountStatuses.statuses)
  }, [accountStatuses])

  return { data: inputStages, ...rest }
}

export const useWillStageCreateUser = (): ((statusId: AccountStatusId) => boolean) => {
  const { data } = useAccountStatuses()

  const createUserIndex = useMemo(() => {
    return data?.statuses.findIndex((status) => status.createUser) ?? -1
  }, [data])

  return useCallback(
    (statusId: AccountStatusId) => {
      const statusIndex = data?.statuses.findIndex((status) => status.statusId === statusId) ?? -1
      return statusIndex >= createUserIndex || createUserIndex === -1
    },
    [data, createUserIndex]
  )
}
